import { render, staticRenderFns } from "./CertificateBlankStatus.vue?vue&type=template&id=4cecb3fa&scoped=true&"
import script from "./CertificateBlankStatus.vue?vue&type=script&lang=js&"
export * from "./CertificateBlankStatus.vue?vue&type=script&lang=js&"
import style0 from "./CertificateBlankStatus.vue?vue&type=style&index=0&id=4cecb3fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cecb3fa",
  null
  
)

export default component.exports